var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLowPoor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10.824,
    viewBox: "0 0 14 10.824",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(317.446 -267.944)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-313.095,269.7l-.409.307a5.209,5.209,0,0,0-2.092,4.179,5.239,5.239,0,0,0,.042.7l.072.517-1.84.241-.06-.505a7.083,7.083,0,0,1,2.766-6.608l.409-.307Z",
    transform: "translate(0 -0.11)",
    fill: "#ed7000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-313.655,277.945h9.2a5.674,5.674,0,0,0,1.142-3.436,5.748,5.748,0,0,0-5.752-5.743,5.755,5.755,0,0,0-2.062.384l-.3-.765a6.568,6.568,0,0,1,8.49,3.764,6.565,6.565,0,0,1,.44,2.361,6.49,6.49,0,0,1-1.443,4.1l-.12.153h-9.988l-.12-.153a6.557,6.557,0,0,1-.9-1.479l.752-.329A5.686,5.686,0,0,0-313.655,277.945Z",
    transform: "translate(-0.948)",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-312.374,274.914l3.376,1.9a1.213,1.213,0,0,1,.757-.268,1.24,1.24,0,0,1,1.249,1.23h0a1.24,1.24,0,0,1-1.23,1.248h0a1.239,1.239,0,0,1-1.248-1.23h0a1.254,1.254,0,0,1,.031-.288l-3.337-1.874Zm4.133,3.266a.41.41,0,0,0,.41-.41h0a.41.41,0,0,0-.409-.41h0a.409.409,0,0,0-.41.409h0a.41.41,0,0,0,.408.41Z",
    transform: "translate(-1.862 -2.779)",
    fill: "#afafaf"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLowPoor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/low-poor.00f7c7bf58aace661f35383187929baf.svg";